import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date as YYYY-MM-DD in the user's LOCAL timezone.
 *
 * `Date.prototype.toISOString()` returns the date in UTC, which shifts the
 * day by ±1 for anyone whose timezone offset is non-zero (e.g. UK BST).
 * That caused the diary picker to record yesterday's date when the user
 * clicked on today. Always use this helper for diary/calendar/date inputs.
 */
export function localYmd(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
